<template>
	<section :class="'cmspos-' + position + ' tile is-vertical is-6'" v-if="position == 'main-page' && contents.length > 0">
		<div v-for="(item, key) in contents" v-bind:key="key" class="cms cmspos-item tile is-parent">
			<div class="tile is-child box tile-left">
				<div class="overlay">
					<h2 v-html="item.title" class="title"></h2>
					<div v-html="item.body" class="body"></div>
				</div>
			</div>
		</div>
	</section>
	<section v-else-if="contents.length > 0">
		<section :class="'cmspos-' + position" v-if="position == 'header'">
			<div class="container">
				<b-notification type="is-danger" :aria-close-label="$t('Close notification')">
					<div v-for="(item, key) in contents" v-bind:key="key" class="cms cmspos-item">
						<div v-html="item.body" class="body"></div>
					</div>
				</b-notification>
			</div>
		</section>
		<section :class="'cmspos-' + position" v-else>
			<Loading :active.sync="loading"></Loading>
			<section>
				<div v-for="(item, key) in contents" v-bind:key="key" class="cmspos-item">
					<div v-html="item.body" class="body"></div>
				</div>
			</section>
		</section>
	</section>
</template>

<script>
import Loading from 'vue-loading-overlay'

export default {
	name: 'Cmspos',
	components: {
		Loading,
	},
	props: {
		position: String,
	},
	data() {
		return {
			loading: true,
			contents: [],
			loadedLang: localStorage.getItem('lang'),
			loaded: false,
		}
	},
	mounted() {
		var _this = this
		this.load()
		this.$root.$on('change_locale', (param) => {
			if (_this.loaded == false || _this.loadedLang != localStorage.getItem('lang')) {
				console.log('Cmspos change_locale:', param)
				_this.load()
			}
		})
	},
	watch: {
		position: function () {},
	},
	methods: {
		load: function () {
			var _this = this
			var _lang = localStorage.getItem('lang')
			var _position = (_lang ? _lang : 'hu') + '-' + this.position
			console.log('________:' + _position)
			this.$http
				.get('/cms/' + _position)
				.then((response) => {
					console.log('CMSPOS:', response)
					if (response.data.cms !== undefined) {
						_this.contents = response.data.cms
					}
					_this.loadedLang = _lang
					_this.loaded = true
					_this.loading = false
				})
				.catch((error) => {
					console.log('get cms', error)
					_this.loading = false
				})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.cmspos-header .notification {
	margin: 1.5rem;
	position: fixed;
	z-index: 30;
	left: 0;
	right: 0;
}
.cmspos-header p:last-of-type {
	margin-bottom: 0;
}
</style>
